import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { useEffect, useRef } from "react";

const AZUL_META = "#0866FF";
const PINO = L.divIcon({
  className: "",
  html: `<div style="width:18px;height:18px;border-radius:50%;background:${AZUL_META};border:3px solid #fff;box-shadow:0 0 0 2px ${AZUL_META}"></div>`,
  iconSize: [18, 18], iconAnchor: [9, 9],
});

/**
 * O pino da loja e o círculo do raio da campanha (só leitura: o pino é
 * ajustado na tela Anúncios Meta). O mapa sempre mostra o círculo inteiro.
 */
export default function MapaRaio({ latitude, longitude, raioKm, altura = "h-64" }) {
  const divRef = useRef(null);
  const mapaRef = useRef(null);
  const circuloRef = useRef(null);

  useEffect(() => {
    if (!divRef.current || mapaRef.current || latitude == null) return undefined;
    const mapa = L.map(divRef.current, { zoomControl: true, scrollWheelZoom: false, dragging: false }).setView([latitude, longitude], 13);
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", { attribution: "© OpenStreetMap" }).addTo(mapa);
    L.marker([latitude, longitude], { icon: PINO, interactive: false }).addTo(mapa);
    circuloRef.current = L.circle([latitude, longitude], { radius: raioKm * 1000, color: AZUL_META, weight: 2, fillOpacity: 0.1 }).addTo(mapa);
    mapaRef.current = mapa;
    // O Leaflet mede o contêiner uma vez só; se a largura mudar depois, sobra uma faixa cinza.
    const medidor = new ResizeObserver(() => {
      mapa.invalidateSize();
      mapa.fitBounds(circuloRef.current.getBounds(), { padding: [20, 20] });
    });
    medidor.observe(divRef.current);
    return () => { medidor.disconnect(); mapa.remove(); mapaRef.current = null; circuloRef.current = null; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [latitude, longitude]);

  useEffect(() => {
    if (!mapaRef.current || !circuloRef.current) return;
    circuloRef.current.setRadius(raioKm * 1000);
    mapaRef.current.fitBounds(circuloRef.current.getBounds(), { padding: [20, 20] });
  }, [raioKm]);

  return <div ref={divRef} className={`${altura} w-full rounded-lg overflow-hidden border`} style={{ zIndex: 1 }} data-e2e="impulsionar-mapa" />;
}
